<template>
  <div class="component-bling">
    <div class="breadcrumbs d-flex align-items-center font-weight-bold mb-9">
      <router-link :to="{ name: 'home' }" class="text-secondary"
        >Início</router-link
      >
      <i class="icon-angle-right text-secondary mx-3"></i>
      <router-link :to="{ name: 'tools' }" class="text-secondary">
        Ferramentas
      </router-link>
      <i class="icon-angle-right text-secondary mx-3"></i>
      <router-link :to="{ name: 'tools-invoices' }" class="text-secondary">
        Notas fiscais
      </router-link>
      <i class="icon-angle-right text-secondary mx-3"></i>
      Bling
    </div>

    <h6 class="d-none d-lg-block">Bling</h6>
    <div class="row align-items-center mb-5 pt-6">
      <div class="col-lg-3 mb-3">
        <div class="d-flex align-items-center">
          <div class="mr-5">Integrações</div>
          <button
            class="btn btn-sm btn-outline-primary btn-square-sm p-5"
            @click="dispatch"
          >
            <i class="icon-refresh-ccw" />
          </button>
        </div>
      </div>
      <div class="col-lg-9">
        <div class="d-flex algn-items-center justify-content-end">
          <button
            type="button"
            class="btn btn-primary px-5 px-lg-6"
            @click="modal = true"
          >
            <span class="d-none d-lg-inline">
              Adicionar
            </span>
            <i class="icon-plus d-lg-none lead"></i>
          </button>
        </div>
      </div>
    </div>
    <div v-if="loading" class="text-center">
      <b-spinner variant="primary" />
    </div>
    <div v-else>
      <div
        v-if="!integrationList.length"
        class="centralize-row text-center pt-5"
      >
        <div class="row justify-content-center">
          <div class="col-lg-5">
            <img
              class="d-block my-9 mx-auto"
              src="@/assets/images/home/welcome.png"
            />
            <h5>Você ainda não adicionou nenhuma integração</h5>
            <div class="text-secondary mb-5">
              Clique no botão acima para cadastrar
            </div>
          </div>
        </div>
      </div>
      <!-- Desktop area -->
      <div v-else>
        <data-table
          class="d-none d-lg-block"
          :columns="columns"
          :data="integrationList"
          columnsFr="1fr 1fr 1.5fr 0.3fr 0.2fr"
        >
          <template #default="{ item }">
            <small class="d-flex align-items-center pr-3">
              {{ productName(item) }}
            </small>
            <small class="d-flex align-items-center pr-3">
              {{ item.client_id }}
            </small>
            <small class="d-flex align-items-center">
              {{ item.client_secret }}
            </small>
            <small class="d-flex align-items-center">
              <strong :class="item.status ? 'text-success' : 'text-danger'">{{
                item.status ? "Ativo" : "Inativo"
              }}</strong>
            </small>
            <div class="d-flex align-items-center justify-content-end">
              <actions-dropdown
                :left="false"
                :right="true"
                :actions="getActions(item)"
                @change-status="changeStatus(item)"
                @delete="submitDelete(item)"
                @login="loginBling(item.token)"
                @edit="edit(item)"
              />
            </div>
          </template>
        </data-table>
        <!-- Desktop area -->
        <!-- Mobile area -->
        <data-table
          class="d-lg-none"
          :columns="columns"
          :data="integrationList"
          columnsFr="1fr 0.2fr"
        >
          <template #default="{ item }">
            <div class="d-flex flex-column text-left pl-3 py-5">
              <small class="d-flex align-items-center">
                <strong class="mr-3">Produto: </strong>
                {{ productName(item) }}
              </small>
              <small class="d-flex align-items-center pr-3">
                <strong class="mr-3">Client ID:</strong>
                {{ item.client_id }}
              </small>
              <small class="d-flex align-items-center">
                <strong class="mr-3">Client Secret:</strong>
                {{ item.client_secret }}
              </small>
              <small class="d-flex align-items-center">
                <strong class="mr-3">Status: </strong>
                <strong :class="item.status ? 'text-success' : 'text-danger'">{{
                  item.status ? "Ativo" : "Inativo"
                }}</strong>
              </small>
            </div>
            <div class="d-flex justify-content-end">
              <actions-dropdown
                :left="false"
                :right="true"
                :actions="getActions(item)"
                @change-status="changeStatus(item)"
                @edit="edit(item)"
                @login="loginBling(item.token)"
                @delete="submitDelete(item)"
              />
            </div>
          </template>
        </data-table>
      </div>
      <!-- Mobile area -->
      <div v-if="integrationList.length" class="d-flex justify-content-center">
        <paginator :pagination="pagination" @on-update="dispatch" />
      </div>
    </div>
    <bling-modal
      v-model="modal"
      :login="token"
      :integrationToEdit="integrationToEdit"
      @clear-edit="
        integrationToEdit = null;
        token = '';
      "
      @update-list="dispatch"
    />
  </div>
</template>
<script>
import blingModal from "@/components/tools/modals/Bling.vue";
import IntegrationsMixin from "@/mixins/integration.js";
import get from "lodash/get";
import { mapState } from "vuex";
export default {
  mixins: [IntegrationsMixin],
  components: {
    blingModal
  },
  mounted() {
    this.$store.commit("integration/setIntegration", this.integration);
    this.dispatch();
  },
  data() {
    return {
      integration: "bling",
      integrationToEdit: null,
      columns: ["Produto", "Client-ID", "Client-Secret", "Status", ""],
      loading: false,
      modal: false,
      search: "",
      token: ""
    };
  },
  computed: {
    ...mapState("product", ["products"]),
    ...mapState("integration", ["integrationList", "pagination"])
  },
  methods: {
    loginBling(token) {
      this.$store.dispatch("integration/getBlingHtml", token).then(response => {
        if (!response.auth_status) {
          window.open("", "_blank").document.write(response);
        }
      });
    },
    getStatusColor(status) {
      const colorMap = {
        enable: "text-success",
        review: "text-warning",
        disable: "text-danger",
        fail: "text-danger"
      };
      return colorMap[status];
    },
    getStatusMessage(status) {
      const messageMap = {
        enable: "Ativo",
        review: "Em revisão",
        disable: "Inativo",
        fail: "Token inválido"
      };
      return messageMap[status];
    },
    productName(item) {
      return get(
        this.products.find(p => p.id === item.product_id),
        "name",
        "-"
      );
    },
    getActions(item) {
      return [
        {
          text: item.status ? "Desativar" : "Ativar",
          class: item.status ? "text-danger" : "text-success",
          icon: "icon-power",
          confirmation: {
            enable: false,
            text: ""
          },
          event: "change-status"
        },
        {
          text: "Logar novamente",
          class: "",
          icon: "icon-refresh-ccw",
          confirmation: {
            enable: false,
            text: ""
          },
          event: "login"
        },
        {
          text: "Editar",
          class: "",
          icon: "fa-solid fa-pen",
          confirmation: {
            enable: false,
            text: ""
          },
          event: "edit"
        },
        {
          text: "Remover",
          class: "text-danger",
          icon: "icon-trash",
          confirmation: {
            enable: true,
            text: "Deseja mesmo remover esta integração?"
          },
          event: "delete"
        }
      ];
    },
    dispatch() {
      this.$store.dispatch("product/get", { limit: 500 });

      let params = { search: this.search };

      this.loading = true;
      this.$store
        .dispatch("integration/getIntegration", params)
        .catch(error => {
          this.$message.error("Não foi possível carregar as contas integradas");
        })
        .finally(() => {
          this.loading = false;
        });
    },
    changeStatus(item) {
      let data = item;
      data.status = !item.status;
      this.$store
        .dispatch("integration/putIntegration", data)
        .then(() => {
          this.$message.success(
            `Integração ${data.status ? "ativada" : "desativada"}`
          );
        })
        .catch(() => {
          this.$message.error(
            "Não foi possível alterar o status da integração"
          );
        });
    }
  }
};
</script>
